
module.exports = {
  GLOBAL_COLOR :{
    DEFAULT_TEXT_COLOR : '#000',
    DARK_GRAY_COLOR : '#666',
    LIGHT_GRAY_COLOR : '#DDD',
    DEFAULT_BORDER_COLOR : '#808080',
    DEFAULT_BACKGROUND_COLOR : '#FFF',
    DEFAULT_SELECTION_COLOR : '#41C7D6',
    TRANSPARENT_COLOR : 'rgba(0,0,0,0)',
    SYSTEM_BLANK : '#000',
    SYSTEM_WHITE : '#FFF',
    SYSTEM_GRAY : '#999'
  }
};

/*
 COLOR_SYS_TEXT = $FF1A1A1A;

 // 系统文字浅色
 COLOR_SYS_TEXT_LIGHT = $FF8C8C8C;

 // 系统选择区颜色
 COLOR_SYS_SELECT = $FF41C7D6;

 COLOR_SYS_SELECT_LIGHTER = $FFBEEDF3;

 // 系统选择区颜色（浅，个别情况下，为突出文字颜色而使用）
 COLOR_SYS_SELECT_LIGHT = $FF5CD0E0;

 // 系统选择区颜色深
 COLOR_SYS_SELECT_DARK = $FF1E828C;

 // 系统组件的边框颜色
 COLOR_SYS_CONTROL_BORDER = $FF999999;
 COLOR_SYS_CONTROL_FACE = $FFF0F0F0;

 // 系统边框颜色
 COLOR_SYS_FRAME = $FFB9B9B9; // $FF999999;

 // 系统边框颜色浅
 COLOR_SYS_FRAME_LIGHT = $FFE0E0E0;

 // 系统边框颜色深
 COLOR_SYS_FRAME_DARK = $FF393939;//和默认menu边框颜色保持一致

 // 系统边框颜色深
 COLOR_SYS_FRAME_DARKER = $FF191919;

 // 系统内容区颜色，如listbox等
 COLOR_SYS_CONTENT = $FFFAFAFA;

 // 系统面板颜色（面板如主菜单bar、主工具栏、浮动工具面板等）
 COLOR_SYS_FACE = $FFE5E5E5;

 // 系统面板颜色（更浅）
 COLOR_SYS_FACE_LIGHTER = $FFF9F9F9;

 // 系统面板颜色（浅）
 COLOR_SYS_FACE_LIGHT = $FFF3F3F3;

 // 系统面板颜色深（小工具栏）
 COLOR_SYS_FACE_DARK = $FFC7C7C7;

 // 系统面板颜色更深（工作区背景等）
 COLOR_SYS_FACE_DARKER = $FF949494;

 // COLOR_SYS_FACE_DARKEST = $FF666666;
 // COLOR_SYS_FACE_DARKEST = $FF666662;
 COLOR_SYS_FACE_DARKEST = $FF505050;

 //
 COLOR_SYS_FACE_PREVIEW = $FF0D6CB4;

 // 系统内容工作区颜色（如左右侧列表颜色、原型图工作区默认底色）
 COLOR_SYS_WORKER_CONTENT = $FFFFFFFF;

 // 树节点拖动时，拖动标记颜色值。
 COLOR_SYS_RED = $FFD73300;
 COLOR_SYS_RED_LIGHT = $FFEB6840;
 COLOR_LINK_RED = $FFFF461F;

 COLOR_SYS_BLUE = $FF2E83E9;

 COLOR_SYS_YELLOW = $FFFACF4E; // $FFFFDC51;
 COLOR_SYS_YELLOW_DARK = $FF725603;
 COLOR_SYS_YELLOW_DARKER = $FF403102;

 COLOR_SYS_LINK = $FFFF461F;
 COLOR_SYS_LINK_LIGHT = $A0FF461F;
 */


// WEBPACK FOOTER //
// ./src/types/GlobalConst.js